var vPort = 'screen-md';

function navStickyPadding() {
    var navSticky = $('.pages-nav--sticky'),
        navRes = navSticky.find('.pages-nav--res');

    if (navSticky.length && navRes.length) {
        navSticky.css('top', $('.pageHeader').height());
    }
}

const hubpageMenuA11Y = () => {
    const hubpageNavbarList = document.querySelector('.hubpage-menu__nav > ul'),
        emptyListItems = hubpageNavbarList?.querySelectorAll('li'),
        menuItems = document.querySelectorAll('.hubpage-menu__nav .menu-parent');

    hubpageNavbarList?.setAttribute('role', 'menubar');
    emptyListItems?.forEach(element => {
        if (!element.classList.value) {
            element.classList.add('menu-parent');
            element.setAttribute('role', 'presentation');
            const emptyLinkItem = element.querySelector('a');
            emptyLinkItem?.classList.add('w-slide__btn');
            emptyLinkItem?.setAttribute('role', 'menuitem');
        }
    });

    menuItems?.forEach(menuItem => {
        const menuToggle = menuItem.querySelector('.dropdown__toggle'),
            submenu = menuItem?.querySelector('.dropdown__menu'),
            menuLinks = submenu?.querySelectorAll('a');

        menuItem.setAttribute('role', 'presentation');
        menuToggle?.setAttribute('aria-haspopup', 'true');
        menuToggle?.setAttribute('aria-expanded', 'false');
        menuToggle?.setAttribute('role', 'menuitem');
        submenu?.setAttribute('role', 'menu');

        menuLinks?.forEach(link => {
            link.setAttribute('role', 'menuitem');
            link.closest('li').setAttribute('role', 'presentation');
        });
    });
};

window.addEventListener('load', () => {
    $('body').on('click', '[ data-db-target-for="hub-menu"]', function (e) {
        if ($(this).hasClass('js--open')) {
            $(this)
                .find('span')
                .css('top', $('.pageHeader').height() - $(this).offset().top - 20);
            $('.hubpage-menu').css('top', $('.pageHeader').height());
            $('body, html').addClass('lock-screen');
            $('.w-slide').addClass('hubMenu-slide').css('top', $('.pageHeader').height());
        } else {
            UX.slide.on.hide(e);
            $('body, html').removeClass('lock-screen');
            $('.w-slide').removeClass('hubMenu-slide');
        }
        UX.slide.on._hideSlide();
    });

    $('.hubpage-menu').removeClass('menu--res');

    $(window).on('resize', function () {
        $('.hubpage-menu').removeClass('menu--res');

        navStickyPadding();
    });

    $('body').on(
        'click',
        '.coolBar--res [data-db-target-for], .pages-nav .menu--res [data-db-target-for], .pages-nav--res [data-db-target-for] ,.showPublications [data-db-target-for] ,.doSearch [data-db-target-for].result__ctrl__filters',
        function () {
            if ($(this).hasClass('js--open')) {
                $('body, html').addClass('lock-screen');
            } else {
                $('body, html').removeClass('lock-screen');
            }
        }
    );

    const hubPageMenu = document.querySelector('.hubpage-menu__nav');
    hubPageMenu && hubpageMenuA11Y();
});

$(document).on(vPort + '-off', function () {
    var $hubPageMenuNav = $('.hubpage-menu__nav'),
        $hubpageMenuBurger = $('[data-db-target-for="hub-menu"]'),
        $wSlideContent = $('.w-slide__content'),
        originalTarget = null,
        $originalTargetMenu = null;

    if ($('.js--fixed-switch').length) {
        $('.js--fixed-switch').addClass('fixed-element');
    }

    if ($hubPageMenuNav.length && $hubPageMenuNav.hasClass('js--open')) {
        $hubPageMenuNav.removeClass('js--open');
        $hubpageMenuBurger
            .removeClass('js--open')
            .attr('aria-expanded', 'false')
            .find('i')
            .removeClass('icon-close_thin');
    }

    if ($wSlideContent && $wSlideContent.find('.menu-items-container').length) {
        (originalTarget = $wSlideContent.attr('original-target')), ($originalTargetMenu = $(originalTarget));

        $originalTargetMenu.html('');
        $wSlideContent.removeAttr('original-target').find('.menu-items-container').appendTo($originalTargetMenu);
    }
});

$(document).on(vPort + '-on', function () {
    var $hubPageMenu = $('.hubpage-menu');

    if ($('.js--fixed-switch').length) {
        $('.js--fixed-switch').removeClass('fixed-element');
    }

    if ($hubPageMenu.length && $hubPageMenu.find('.dropdown__toggle').length) {
        $hubPageMenu.find('.dropdown__toggle').each(function (index, element) {
            if ($(element).hasClass('js--open hover')) {
                $(element).removeClass('js--open hover').attr('aria-expanded', 'false');
            }
        });
    }

    navStickyPadding();
});

$(document).on('click', '.coolBar--res [data-db-target-for]', function () {
    const dataDBOf = $('[data-db-target-of="' + $(this).data('db-target-for') + '"]');

    if (!$(this).hasClass('js--open')) {
        dataDBOf.find('li').eq(0).find('a').focus();
    }
});

$(document).on('click', '[data-toggle="modal"]', function (e) {
    if ($('.hubpage-menu').length) {
        $('.hubpage-menu nav').css('z-index', '8');
    }
});

$(document).on('click', '[data-dismiss="modal"]', function (e) {
    if ($('.hubpage-menu').length) {
        $('.hubpage-menu nav').css('z-index', '11');
    }
});

$('.ux-modal-container').click(function (e) {
    if (!$(e.target).is('[data-dismiss="modal"]') && !$(e.target).parents().is('.modal__dialog')) {
        $('.hubpage-menu nav').css('z-index', '11');
    }
});
